import { Button } from '../../components/Button';
import { useState } from 'react';
import { createPortal } from 'react-dom';

const instructions = [
  {
    id: 1,
    svg: '/icons/instructions_timer_25sec.svg',
    title: '25 секунд',
    description: 'У вас есть 25 секунд, чтобы определить, нравится ли вам человек или нет'
  },
  {
    id: 2,
    svg: '/icons/instr1.svg',
    title: 'Лайк',
    description: 'Если вам понравился человек и вы хотели бы продолжить общение в переписке – поставтье лайк'
  },
  {
    id: 3,
    svg: '/icons/instr3.svg',
    title: 'Дизлайк',
    description: 'Хотите перейти к следующему собеседнику – поставтье дизлайк'
  },
  {
    id: 4,
    svg: '/icons/instr4.svg',
    title: 'Начать переписку',
    description: 'Не хотите дожидаться симпатии? Напишите первым'
  }
];

export function RouletteInstruction() {
  const [isShowInstruction, setIsShowInstruction] = useState(() => {
    const stored = localStorage.getItem('showed-roulette-instruction-modal-1');
    return stored !== null ? JSON.parse(stored) : true;
  });

  return (
    <>
      <button onClick={() => setIsShowInstruction((prev) => !prev)}>
        <img src="/icons/Button-instruction.svg" className="w-[44px] h-[44px] cursor-pointer" />
      </button>
      {isShowInstruction &&
        createPortal(
          <div
            className="z-[9999] fixed inset-0 flex flex-col bg-black/70 backdrop-blur-[10px]"
            style={{ touchAction: 'pan-y', paddingTop: 'calc(var(--tg-content-safe-area-inset-top, 0px) * 1.7)' }}
          >
            <div className="flex-1 overflow-y-auto pb-[140px] flex justify-start items-center flex-col">
              <h1 className="font-raleway font-bold text-white text-[26px]">Инструкция</h1>
              <h1 className="font-raleway font-light mt-2 text-white text-center text-[18px]">
                Основные функции и жесты
              </h1>
              <div className="grid grid-cols-1 justify-center flex-wrap items-center gap-[16px] mt-[16px] px-4">
                {instructions.map((ins, index) => (
                  <div
                    key={ins.id}
                    className={` pt-[10px] pb-[10px] gap-[12px] border-b ${
                      index === instructions.length - 1 ? 'border-none' : 'border-[#6D6D6D]'
                    } flex text-white`}
                  >
                    <div className="shrink-0 flex justify-center items-center">
                      <img src={ins.svg} className="w-[40px] h-[40px]" alt={ins.title} />
                    </div>
                    <div className={`flex flex-col gap-[4px]`}>
                      <p className={` text-[18px] font-semibold`}>{ins.title}</p>
                      <p className={` text-[14px] font-light`}>{ins.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="fixed bottom-[40px] w-full left-0 right-0 px-4 flex justify-center z-[10000]">
              <Button
                fullWidth
                onClick={() => {
                  setIsShowInstruction(false);
                  localStorage.setItem('showed-roulette-instruction-modal-1', JSON.stringify(false));
                }}
              >
                Понятно
              </Button>
            </div>
          </div>,
          document.getElementById('portal')
        )}
    </>
  );
}

export default RouletteInstruction;
